import { Link } from 'react-router-dom'
import { Modal, ModalActions, modalBtn } from './ui/Modal'
import { productHasCompatibleMachines } from '../lib/productMachines'
import type { PostToWorkTarget } from '../hooks/usePostToWorkModal'
import { alert, btn, cn } from '../lib/ui'

type Props = {
  target: PostToWorkTarget
  machineIdsByProduct: Map<string, string[]>
  onClose: () => void
}

export function PostToWorkModal({ target, machineIdsByProduct, onClose }: Props) {
  const hasMachines = productHasCompatibleMachines(target.productId, machineIdsByProduct)
  const canPost =
    hasMachines &&
    target.lineStatus !== 'cancelled' &&
    target.lineStatus !== 'shipped' &&
    target.lineStatus !== 'completed'

  return (
    <Modal title="Постановка в работу" onClose={onClose}>
      <p className="m-0 text-sm text-su-text">
        <strong>{target.productName}</strong> — {target.quantity} ед.
      </p>
      {!hasMachines && (
        <div className={cn(alert('warn'), 'mt-3 mb-0')}>
          У продукции не указаны совместимые станки. Привяжите станки в карточке продукции, затем повторите
          постановку.
        </div>
      )}
      {hasMachines && !canPost && (
        <div className={cn(alert('warn'), 'mt-3 mb-0')}>
          Строка в статусе «{target.lineStatus}» — постановка недоступна.
        </div>
      )}
      {canPost && (
        <p className="mt-3 mb-0 text-sm text-su-text">
          Создание слотов графика выполняется в разделе «Планирование». Перейдите в очередь или Gantt, выберите
          строку заявки и укажите станок из списка совместимых.
        </p>
      )}
      <ModalActions>
        {canPost && (
          <Link to="/planning/queue" className={modalBtn('primary')} onClick={onClose}>
            К очереди планирования
          </Link>
        )}
        <button type="button" className={btn('ghost')} onClick={onClose}>
          Закрыть
        </button>
      </ModalActions>
    </Modal>
  )
}
